//console.log("renderer.js is now loaded!");

const basePath = window.bundleBasePath || '/dev'; // fallback just in case
let isDebug = false;
if (window.bundleBasePath === '/dev') {
    isDebug = true;
}

console.log(isDebug);

ScriptController.loadAndRun([`${basePath}/classes/bulma.js`], {
    runOn: 'DOMContentLoaded',
    debug: isDebug,
    callback: () => {
        const bulma = new window.Bulma(true);
        bulma.init(['navigation', 'dropdowns', 'accordions','onScroll','modals','responsiveVideos','downloadRelocation','articleDownloadRelocation','articleImgRelocation','symbolWrapping','contentSlider','searchFeatures']);
    }
});


ScriptController.loadAndRun([`${basePath}/classes/form.js`], {
    runOn: 'DOMContentLoaded',
    debug: isDebug,
    callback: () => { 
        
        const forms = document.querySelectorAll('.pf-form');
        forms.forEach(formEl => {
            new Form(formEl, true, true); // or false/true depending on your validate/debug flags
        });
    }
});
       
ScriptController.loadAndRun([`${basePath}/classes/particles.js`], {
    runOn: 'DOMContentLoaded',
    debug: isDebug,
    callback: () => {
        const canvasEls = document.querySelectorAll(".overlay-particles");

        if (canvasEls.length === 0) {
            console.warn("[Particles] Skipped: No elements with class .overlay-particles found.");
            return;
        }

        canvasEls.forEach((canvasEl, index) => {
            new Particles(canvasEl, {
                count: 120,
                maxDistance: 120,
                dotColor: "#fff",
                lineColor: "#ccc",
                speed: 1
            });
        });
    }
});
